<template>
  <div id='resource-removed' class="uk-flex-top" uk-modal>
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto uk-margin-auto-vertical">
      <span class="uk-modal-title heading">{{$t('modals.resourceRemoved.title')}}</span>
      <p class="message">{{$t('modals.resourceRemoved.body')}}</p>
      <p class="uk-text-right">
        <button class="button add-pointer uk-modal-close uk-text-capitalize" @click="leavePage">{{$t('modals.resourceRemoved.button')}}
        </button>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'resource-removed',
    methods: {
      leavePage() {
        this.$emit('leave-page')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../styles/colours';
  @import '../../../styles/breakpoints';

  .heading {
    font-size: 24px;
    font-weight: bold;
    margin-left: 32px;
    margin-top: 32px;
    color: $content-text;
  }

  .message {
    margin-left: 32px;
    margin-top: 32px;
    font-size: 20px;
    color: $content-text;
  }

  .cancel-button {
    width: 238px;
    height: 44px;
    margin-right: 24px;
    border-radius: 2px;
    border: solid 2px $text-area-background;
    font-size: 18px;
    font-weight: bold;
    color: $text-area-background;

    &:hover {
      border-radius: 2px;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
      border: solid 2.8px white;
      background-color: white;
      color: $nepal;
    }
  }

  .button {
    width: 238px;
    height: 44px;
    border-radius: 2px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    border: solid 2.8px $light-blue;
    background-color: $light-blue;
    font-size: 18px;
    font-weight: bold;
    color: white;

    &:hover {
      border-radius: 2px;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
      border: solid 2.8px white;
      background-color: white;
      color: $light-blue;
    }
  }

  .uk-text-right {
    margin-top: 56px
  }

  .uk-modal-dialog {
    width: 900px;
    min-height: 252px;
    border-radius: 2.8px;
    box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
    background-color: $lightest-gray;
  }

  @media screen and (max-width: $breakpoint-medium) {
    .button {
      width: 200px;
    }
  }

  @media screen and (max-width: $breakpoint-small) {
    .button {
      display: block;
      width: 100%;
      margin-right: 0;
      margin-bottom: 10px;
    }

    .heading {
      margin-left: 0;
    }

    .message {
      margin-left: 0;
    }
  }
</style>
